// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"f522cf40","398":"9840805f","453":"eaac9f30","686":"e9d7a868","878":"cf049b2f","906":"8d5dafdc"}[chunkId] + ".chunk.js";
};